module.exports = __webpack_public_path__ + "static/media/dot.063e0ac8.svg";